import { IPubSubInstruction } from '@dadohr/shared/domainTypes/pubsub';
import { callFirebaseFunction } from '../../../services/firebaseFunctions';

export const publishTopic = (d: IPubSubInstruction) => {
  return callFirebaseFunction('pubsub-publishJson', d);
};
